module.exports = new Promise((resolve) => {
    const script = document.createElement('script');
    let settled = false;
    const fail = (message) => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      console.warn(message);
      resolve({
        get: () => Promise.reject(new Error(message)),
        init: () => undefined
      });
    };
    script.src = 'https://app.bellwetherit.com/assets/hunt-board/remoteEntry.js';
    script.onload = () => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      resolve({
        get: (request) => window['huntBoardRemote']
          ? window['huntBoardRemote'].get(request)
          : Promise.reject(new Error('Module huntBoardRemote not available')),
        init: (shareScope) => {
          try {
            return window['huntBoardRemote'] ? window['huntBoardRemote'].init(shareScope) : undefined;
          } catch (error) {
            console.warn('huntBoardRemote init failed:', error);
            return undefined;
          }
        }
      });
    };
    script.onerror = () => fail('Failed to load remote: huntBoardRemote');
    const deadline = setTimeout(() => fail('Timed out loading remote: huntBoardRemote'), 10000);
    document.head.appendChild(script);
  });